import { readPlatformSessionIdFromPageEntry } from '@/common/utils/platformFileSession'
import { normalizePlatformSessionId } from '@/common/utils/jsRequestSessionContext'

export type ReloadPanelSessionContext = {
  sessionId?: string | number | null
  eventCoreId?: string | number | null
}

/**
 * sessionId для reload/panel: актуальный pagesData > context.sessionId > eventCoreId (fallback).
 * eventCoreId из WS часто указывает на уничтоженный auxiliary core после delete/change_doc.
 */
export function resolveReloadPanelSessionId(
  context: ReloadPanelSessionContext | undefined | null,
  pageEntries: unknown[],
): string | null {
  for (const entry of pageEntries) {
    const fromHelper = readPlatformSessionIdFromPageEntry(entry)
    if (fromHelper) return fromHelper
    const direct = normalizePlatformSessionId((entry as { sessionId?: unknown } | null)?.sessionId)
    if (direct) return direct
  }

  const fromContext = normalizePlatformSessionId(context?.sessionId)
  if (fromContext) return fromContext

  return normalizePlatformSessionId(context?.eventCoreId)
}
